import React from 'react';
import { Section } from './Section';
import { CheckCircle2, AlertCircle } from 'lucide-react';
export function StackSection() {
  const stackItems = [{
    name: 'Adiós Hinchazón: 3-Day Reset — Guía principal',
    value: '$37'
  }, {
    name: 'BONO 1 — Kit de Arranque 24H',
    value: '$17'
  }, {
    name: 'BONO 2 — Lista Express de Supermercado',
    value: '$17'
  }, {
    name: 'BONO 3 — Reset Nocturno de 5 Minutos',
    value: '$17'
  }];
  return <Section className="bg-forest text-cream" data-id="element-332">
      <div className="max-w-4xl mx-auto" data-id="element-333">
        <h2 className="font-serif text-3xl md:text-4xl font-bold mb-10 text-center text-gold" data-id="element-334">
          Esto es todo lo que recibes hoy cuando accedes ahora:
        </h2>

        <div className="bg-white text-forest rounded-2xl shadow-2xl overflow-hidden mb-10" data-id="element-335">
          <div className="overflow-x-auto" data-id="element-336">
            <table className="w-full text-left border-collapse" data-id="element-337">
              <thead data-id="element-338">
                <tr className="bg-sage border-b-2 border-forest/10" data-id="element-339">
                  <th className="py-4 px-6 font-serif font-bold text-xl" data-id="element-340">
                    Lo que recibes
                  </th>
                  <th className="py-4 px-6 font-serif font-bold text-xl text-right" data-id="element-341">
                    Valor
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-342">
                {stackItems.map((item, index) => <tr key={index} className="border-b border-gray-100 last:border-0 hover:bg-gray-50 transition-colors" data-id="element-343">
                    <td className="py-4 px-6 flex items-center gap-3 text-lg font-medium" data-id="element-344">
                      <CheckCircle2 className="w-6 h-6 text-green-500 flex-shrink-0" data-id="element-345" />
                      {item.name}
                    </td>
                    <td className="py-4 px-6 text-right text-lg text-gray-500 line-through" data-id="element-346">
                      {item.value}
                    </td>
                  </tr>)}
                <tr className="bg-forest-light text-cream border-b border-forest" data-id="element-347">
                  <td className="py-5 px-6 font-serif font-bold text-xl uppercase tracking-wider" data-id="element-348">
                    Valor Total
                  </td>
                  <td className="py-5 px-6 text-right font-bold text-2xl line-through text-cream/70" data-id="element-349">
                    $88
                  </td>
                </tr>
                <tr className="bg-gold text-forest" data-id="element-350">
                  <td className="py-6 px-6 font-serif font-bold text-2xl md:text-3xl" data-id="element-351">
                    Lo que pagas hoy
                  </td>
                  <td className="py-6 px-6 text-right font-bold text-3xl md:text-4xl" data-id="element-352">
                    $14 <span className="text-xl" data-id="element-353">USD</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="text-center space-y-2 mb-12 text-lg md:text-xl text-cream-dark font-medium" data-id="element-354">
          <p data-id="element-355">
            Todo en español. Todo en formato digital. Todo disponible desde el
            momento en que accedes.
          </p>
          <p data-id="element-356">Sin esperar. Sin envíos. Sin complicaciones.</p>
          <p className="text-gold font-bold" data-id="element-357">
            Abres, descargas y empiezas hoy mismo.
          </p>
        </div>

        <div className="bg-gold/10 border border-gold rounded-xl p-6 md:p-8 flex flex-col md:flex-row gap-6 items-start md:items-center" data-id="element-358">
          <AlertCircle className="w-12 h-12 text-gold flex-shrink-0" data-id="element-359" />
          <div className="space-y-2 text-cream-dark" data-id="element-360">
            <p className="font-bold text-gold text-lg" data-id="element-361">
              Estos bonos están disponibles con esta oferta por tiempo limitado.
            </p>
            <p data-id="element-362">
              No porque sea un truco de ventas. Sino porque este precio no es el
              precio con el que lanzaremos esto permanentemente.
            </p>
            <p className="font-medium text-white" data-id="element-363">
              Si estás viendo esta página ahora mismo, todavía puedes acceder
              con todo incluido.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}